import React from 'react'
import Media from 'react-media'
import PropTypes from 'prop-types'

import ContactForm from './ContactForm'

import phoneDark from '../images/icons/telephone-dark.png'
import phone from '../images/icons/telephone.png'

export default class ContactPanel extends React.Component {
  static propTypes = {
    isContact: PropTypes.bool,
  }

  state = { show: false }

  componentDidMount () {
    if (typeof window !== undefined) {
      this.setState({ show: true })
    }
  }

  render () {
    const { isContact } = this.props
    const { show } = this.state
    return (
      <div className="contact-panel">
        <div className="contact-panel__inner">
          <div className="contact-panel__main">
            <div className="contact-panel__block">
              <h2>Get in touch</h2>
              <p>To request a quote or talk with us about your roofing requirements please fill out the form or give us a call.</p>
              <div className="contact-panel__phone">
                { show &&
                  <Media query="(pointer: fine)">
                    { matches => (matches
                      ? <button className="default-button">
                        <img src={isContact ? phone : phoneDark} alt="phone" /><span>0274 284 027</span>
                      </button>
                      : <a href="tel:0274284027">
                        <button className="default-button">
                          <img src={isContact ? phone : phoneDark} alt="phone" /><span>0274 284 027</span>
                        </button>
                      </a>) }
                  </Media> }
              </div>
            </div>
            <div className="contact-panel__block">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ContactPanel.js